import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=4e0ddcfb&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ddcfb",
  null
  
)

export default component.exports